const transparentPixel = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';

// replace the image by the error image if not found
module.exports = function () {
    return {
        restrict: 'A',
        link(scope, element, attrs) {
            element.on('error', () => {
                element.off('error'); // if the error src isn't found don't try to load it repeatedly.

                const olyErrorSrc = attrs.olyErrorSrc && attrs.olyErrorSrc.length > 0
                    ? attrs.olyErrorSrc
                    : transparentPixel;

                attrs.$set('src', olyErrorSrc);
            });

            scope.$on('$destroy', () => {
                element.off('error');
            });
        },
    };
};



// WEBPACK FOOTER //
// ./src/olycommon/error-src/error-src.directive.js